import {
  ContactusAddressSection,
  ContactusFormSection,
  ContactusHero,
} from "@modules/study/contactus";
import { LayoutMain } from "@unisearch/theme/layout";

const ContactUs = () => {
  return (
    <LayoutMain
      title="Contact Us"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/contact-us`}
    >
      <ContactusHero />
      <ContactusFormSection />
      <ContactusAddressSection />
    </LayoutMain>
  );
};

export default ContactUs;
